<template>
  <div class="app-root">
    <!-- Vue Router 顶级视图。
         注意：移除 <transition mode="out-in">，因为 Vue3 Transition + Vue Router 4 在
         异步路由组件 + tabbar route 模式下存在 enter 钩子丢失的静默 bug，
         会导致 leave 完成后 enter 不触发，新组件永久不挂载 → 白屏。
         改用 CSS 视图切换透明度变化即可，不需要 JS transition 控制。 -->
    <router-view v-slot="{ Component, route }">
      <div :key="route.path" class="route-page">
        <component :is="Component" />
      </div>
    </router-view>

    <!-- 全局登录引导弹窗（游客模式：40101 触发 / 我的 Tab 拦截） -->
    <LoginGuidePopup />

    <!-- 全局微信分享引导浮层（点击右上角 ··· 的轻提示，非强制） -->
    <ShareGuidePopup />

    <!-- 全局微信浮窗引导横幅（关键动作完成后仅弹一次，见 useFloatGuide） -->
    <FloatGuideBanner />
  </div>
</template>

<script setup lang="ts">
// Aries H5 根布局（三层结构：头部固定 / 主体可滚动 / 底部按钮或Tab）
// 每个业务页面负责自己的页面层级，不在这里塞全局业务逻辑
import LoginGuidePopup from '@/components/LoginGuidePopup.vue'
import ShareGuidePopup from '@/components/ShareGuidePopup.vue'
import FloatGuideBanner from '@/components/FloatGuideBanner.vue'
import { useFeatureStore } from '@/store'

// 启动即拉取 C 端全局功能开关（游客可访问，失败按默认开启兜底），
// 供首页/AI红娘/我的页控制「AI情感助理」入口显隐
const featureStore = useFeatureStore()
featureStore.loadFlags()
</script>

<style lang="scss" scoped>
.app-root {
  width: 100vw;
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--color-bg-page);
  color: var(--color-text-primary);
  font-family: var(--font-family-base);
  position: relative;
  /* 不设 overflow（保持 visible）：
     body 已设 overflow-x:hidden 禁止横向滚动；
     若此处设 hidden/clip 会创建滚动容器，导致子页面 position:sticky 的导航栏无法吸附。 */
  // 适配iOS安全边距
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: border-box;
}

.route-page {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  // 轻量 CSS 入场动画，不依赖 Vue Transition 的 JS 钩子，避免 enter 卡死
  animation: route-fade-in 200ms ease;
}

@keyframes route-fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}
</style>
